import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PFLogo from '../assets/logo.svg';

function Footer() {
  const { t, i18n } = useTranslation();
  return (
    <footer className="text-light">
      <div className="container">
        <div className="row g-4">
          {/* Brand Section */}
          <div className="col-12 col-xl-5 text-center text-xl-start mb-4 mb-xl-0">
            <Link
              className="navbar-brand d-inline-flex align-items-center"
              to={i18n.language === 'bs' ? '/' : `/${i18n.language}`}
            >
              <img
                src={PFLogo}
                alt="Logo"
                width={40}
                className="me-2"
              />
              <span className="h5 mb-0 fw-bold">PawFriends Sarajevo</span>
            </Link>
            <p className="mt-3">{t('footer.thank_you_for_your_support')}</p>
          </div>

          {/* Contact Section */}
          <div className="col-12 col-xl-4 text-center text-xl-start mb-4 mb-xl-0">
            <h6 className="fw-bold mb-3">
              <i className="fas fa-envelope me-2"></i>
              {t('footer.contact_us')}
            </h6>
            <ul className="list-unstyled">
              <li>
                <a href="mailto:pawfriendssarajevo@gmail.com">
                  pawfriendssarajevo@gmail.com
                </a>
              </li>
            </ul>
          </div>

          {/* Social Media Section */}
          <div className="col-12 col-xl-3 text-center text-xl-end mb-4 mb-xl-0">
            <h6 className="fw-bold mb-3">
              <i className="fas fa-share-alt me-2"></i>
              {t('footer.follow_us')}
            </h6>
            <ul className="social-list list-inline mb-0 d-flex justify-content-center justify-content-xl-end">
              <li className="list-inline-item">
                <a
                  title="Facebook"
                  href="https://www.facebook.com/pawfriendssarajevo"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-facebook-f"></i>
                </a>
              </li>
              <li className="list-inline-item">
                <a
                  title="Instagram"
                  href="https://www.instagram.com/pawfriends_sarajevo/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-instagram"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Credits and Legal */}
        <div className="row mt-4 pt-4 border-top border-secondary">
          <div className="col-12 col-md-7 text-center text-md-start mb-3 mb-md-0">
            <p className="mb-0">
              Website by{' '}
              <a
                href="https://www.linkedin.com/in/amelaspica"
                target="_blank"
                rel="noopener noreferrer"
              >
                Amela Špica
              </a>
            </p>
          </div>
          <div className="col-12 col-md-5 text-right text-md-end">
            <small style={{ color: '#fff' }}>
              This site is protected by reCAPTCHA and the Google{' '}
              <a
                href="https://policies.google.com/privacy"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#fff', textDecoration: 'underline' }}
              >
                Privacy Policy
              </a>{' '}
              and{' '}
              <a
                href="https://policies.google.com/terms"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#fff', textDecoration: 'underline' }}
              >
                Terms of Service
              </a>{' '}
              apply.
            </small>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
